import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import moment from "moment";
import ReportCollection from "@/classes/ReportCollection";
import WhiteBox from "@/components/WhiteBox.vue";
let Calendar = class Calendar extends Vue {
    // function that loads the holidays data object from the store. Loads locally if available API otherwise.
    loadHolidayData() {
        this.$data.holidayCollection = this.$store.getters.getHolidays;
        if (this.$store.getters.getHolidays === null) {
            const currentYear = moment(this.$store.getters.getSelectedDate).format("YYYY");
            this.$store
                .dispatch("loadHolidaysAsync", { year: currentYear })
                .then((holidays) => {
                this.$store.commit("setHolidays", {
                    data: holidays.data,
                    year: currentYear,
                });
                this.$data.holidayCollection = holidays.data;
            })
                .catch((err) => {
                window.errorHandler.logError(err, "TeamLoadOverview.vue - loadHolidayData");
            });
        }
    }
    getBackgroundColor(report) {
        return this.$store.getters.getGlobalTariffs.getColor(report.tariffId);
    }
    getDayOfMonth(date) {
        if (date === null) {
            return "";
        }
        else {
            return moment(date).format("DD");
        }
    }
    selectPreviousMonth() {
        const oldDate = this.$store.getters.getSelectedDate;
        const newDate = window.dateHandler
            .subtractMonths(this.$store.getters.getSelectedDate, 1)
            .startOf("month")
            .format("YYYY-MM-DD");
        this.$store.commit("setSelectedDate", { date: newDate });
        this.$data.dateInfo = this.$store.getters.getDateInfo;
    }
    selectNextMonth() {
        const oldDate = this.$store.getters.getSelectedDate;
        const newDate = window.dateHandler
            .addMonths(this.$store.getters.getSelectedDate, 1)
            .startOf("month")
            .format("YYYY-MM-DD");
        this.$store.commit("setSelectedDate", { date: newDate });
        this.$data.dateInfo = this.$store.getters.getDateInfo;
    }
};
Calendar = __decorate([
    Component({
        data() {
            return {
                dateInfo: null,
                theme: {},
                reports: null,
                weeks: null,
                holidayCollection: null,
            };
        },
        mounted() {
            this.$store.commit("setSelectedDate", { date: new Date() });
            this.loadHolidayData();
            this.$data.dateInfo = this.$store.getters.getDateInfo;
            this.$data.theme = this.$store.getters.getTheme;
            //this will gernated an error if the holiday data is not updated
            window.eventBus.$on("selectedMonthReportsUpdated", () => {
                const tempReports = new ReportCollection();
                tempReports.importReportObjectsFromJson(this.$store.getters.getSelectedMonthReports); //create a report collection
                if (tempReports !== undefined) {
                    this.$data.reports = tempReports;
                    this.$data.weeks = this.$data.reports.getMonthWeeks();
                }
            });
        },
        components: {
            IconBox,
            IconBoxContent,
            WhiteBox,
        },
    })
], Calendar);
export default Calendar;
